export default __webpack_public_path__ + "static/media/utd.283a1bed.jpeg";